<h1 class="header">Welcome to 5.0 Toolbox</h1>
<img alt="cannedPolicy"
  src="https://dev.reveleer.com/chaseassets/0000f303-95e9-4c92-ae3d-e5c00cdde78b/0000f303-95e9-4c92-ae3d-e5c00cdde78b_000000.png?color=red&size=medium?Expires=1645683408&Signature=Hy1q4SqZawMiauFmLtY56QZ2NvhxxE66XVevYjfQymt3V5oQ6stzOr0XnC01Dkt-Oe-8cyJ~FlbKtZWf2lhzxpUCfnlgsZdtiNAV777~092pdKVBKsmLr0dA7HJpDe-UrC6QAHpUo4IGmJzIYlCai2cyjDcaxPpv2msh6No8lIBElsITZzr2j2JkJMGFW2ek8x~aeeYIomcAlxAYEB3n1rUBXfX2qzhT79i83d6Z2tkpfQaQgim9zRmHv8KaXzJ2gWSzUoQM-9rdXYJCXbDSv0dEehRXPKOJaJmNiZGzIRJ5vl9-CKuKhEAWqJjdNOramgvmQrP9XR0VDzqUVODPTw__&Key-Pair-Id=K3C4F5LP5FADT1">
<app-tab-menu class="toolbox-tabs">
  <app-tab-panel header="Colors">
    <toolbox-colors></toolbox-colors>
  </app-tab-panel>
  <app-tab-panel header="Typography">
    <toolbox-typography></toolbox-typography>
  </app-tab-panel>

  <app-tab-panel header="Icons">
    <toolbox-icons></toolbox-icons>
  </app-tab-panel>

  <app-tab-panel header="Buttons">
    <toolbox-buttons></toolbox-buttons>
  </app-tab-panel>

  <app-tab-panel header="Toast / Message">
    <div class="p-grid">
      <div id="Toast-Example" class="p-col-12">
        <h2>Toast Message Example</h2>
        <app-button (onClick)="showToastSuccess()" text="Success" class="p-button-success"></app-button>
        <app-button (onClick)="showToastInfo()" text="Info" class="p-button-info"></app-button>
        <app-button (onClick)="showToastWarn()" text="Warn" class="p-button-warning"></app-button>
        <app-button (onClick)="showToastError()" text="Error" class="p-button-danger"></app-button>
      </div>
      <div id="Messages-Example" class="p-col-12">
        <h2>Sitewide Message Example</h2>
        <app-button (onClick)="showMessageSuccess()" text="Success" class="p-button-success"></app-button>
        <app-button (onClick)="showMessageInfo()" text="Info" class="p-button-info"></app-button>
        <app-button (onClick)="showMessageWarn()" text="Warn" class="p-button-warning"></app-button>
        <app-button (onClick)="showMessageError()" text="Error" class="p-button-danger"></app-button>
      </div>
      <div id="Tool-tip-Example" class="p-col-12">
        <h2>Tool-tip Example</h2>
        <app-tool-tip
          text="This is sample text. This is an info hover. It will give the user some information about this setting.">
        </app-tool-tip>
      </div>
    </div>
  </app-tab-panel>

  <app-tab-panel header="Form Inputs">
    <toolbox-forms></toolbox-forms>
  </app-tab-panel>

  <app-tab-panel header="Menu">
    <toolbox-menus></toolbox-menus>
  </app-tab-panel>

  <app-tab-panel header="Modals / Panels">
    <toolbox-modals-and-panels></toolbox-modals-and-panels>
  </app-tab-panel>

  <app-tab-panel header="Grid">
    <div class="p-grid">
      <div class="p-col-12">
        <toolbox-basic-grid-demo></toolbox-basic-grid-demo>
      </div>
    </div>
  </app-tab-panel>

  <app-tab-panel header="Document Upload">
    <toolbox-upload></toolbox-upload>
  </app-tab-panel>

  <app-tab-panel header="Document Viewer">
    <div class="document-container">
      <toolbox-document></toolbox-document>
    </div>
  </app-tab-panel>

  <app-tab-panel header="SSRS Report">
    <app-button routerLink="/reporting/ssrs" text="SSRS Report" class="btn-ssrs"></app-button>
  </app-tab-panel>

  <app-tab-panel header="Animations">
    Animations Not Implemented
  </app-tab-panel>

  <app-tab-panel header="Flexbox">
    <app-button routerLink="/toolbox/flex" text="Flexbox" class="btn-ssrs"></app-button>
  </app-tab-panel>
</app-tab-menu>